import Numeral from "numeral";

import Text from "ab-text";

import "./vino-tile.scss";

const VinoTile = ({ product, onClick, selected }) => {
  return (
    <div
      className={`vino-tile${selected ? " selected" : ""}`}
      onClick={onClick}
    >
      <img src={product?.image?.mediaItemUrl} alt={product.name} />
      <Text element="h4">{product.name}</Text>
      <Text element="span" className="title">
        {Numeral(product.price).format("1,000.00$")}
      </Text>
    </div>
  );
};

export default VinoTile;
